// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2O_ks","notes":"Notes_notes__3ArFG"};